import React from 'react';

import SearchIcon from 'mdi-react/MagnifyIcon';
import * as S from './styles';

type SearchProps = {
  inputValue: string;
  onChange: (value: string) => void;
  onFocus: (value: string) => void;
  onSearch: (search: string) => void;
  hasResults?: boolean;
  placeholder?: string;
  setInputValue: (input: string) => void;
};

const Search = ({
  inputValue,
  onChange,
  onFocus,
  onSearch,
  hasResults,
  placeholder,
  setInputValue,
}: SearchProps) => {
  const clearInput = React.useCallback(() => {
    onChange('');
    setInputValue('');
  }, [onChange, setInputValue]);

  const onSearchButtonClick = React.useCallback(() => {
    onSearch(inputValue);
  }, [onSearch, inputValue]);

  const onInputChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void = React.useCallback(
    ({ target }) => {
      onChange(target.value);
      setInputValue(target.value);
    },
    [onChange, setInputValue]
  );

  const handleFocus = React.useCallback(
    e => {
      onFocus(e.target.value);
    },
    [onFocus]
  );

  return (
    <S.Block hasResults={hasResults}>
      <S.Input
        onChange={onInputChange}
        type="text"
        value={inputValue}
        placeholder={placeholder}
        onFocus={handleFocus}
      />
      <S.ClearButton type="button" visible={inputValue} onClick={clearInput}>
        <S.CloseIcon size={20} />
      </S.ClearButton>
      <S.FullSearchButton type="button" onClick={onSearchButtonClick}>
        <SearchIcon />
      </S.FullSearchButton>
    </S.Block>
  );
};

Search.defaultProps = {
  onChange: () => {},
  onFocus: () => {},
  onSearch: () => {},
  hasResults: false,
  placeholder: undefined,
};

export default Search;
